import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'


import {LoadingPlugin} from 'vuetify-loading-overlay'
import Icon from '@/components/Icon'
import VueKonva from 'vue-konva';

import '@/assets/new_design/tailwind.generated.css'
import '@/assets/styles-user-tour.scss'
import { initGoogleAnalytics } from '@/utils/googleAnalytics'
import { initAppUpdateCheck } from '@/utils/appUpdate'

initGoogleAnalytics()
initAppUpdateCheck()

Vue.config.productionTip = false
Vue.use(LoadingPlugin, { spinnerProps: { color:"primary"},  overlayProps: { color: "white" } })
Vue.use(VueKonva)


Vue.component('icon', Icon)

Vue.prototype.$eventBus = new Vue();

store.commit('initializeStore')

const VueApp = new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')

export default VueApp
